import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'flatpickr/dist/themes/material_blue.css'; // or your theme
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.css';
import { useNavigate, useParams } from 'react-router-dom';
import { globalErrorHandler } from '../../../utils/GlobalErrorHandler'
import dayjs from "dayjs";




const GuestIntakeFormView = () => {

  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = Boolean(id);

  const [loading, setLoading] = useState(false);
  const [guest, setGuest] = useState(null);
  const [states, setStates] = useState([]);
    const [guestItems, setGuestItems] = useState([]); // array of added items
        const [monthlyRows, setMonthlyRows] = useState([]);
    

  // Load data on mount
  useEffect(() => {

    getStates();
    if (isEdit) {
      getGuest();
    }
    else {
      const saved = localStorage.getItem('guest-form');
      if (saved)
        setGuest(JSON.parse(saved));
      else
        setGuest({ today: formatDate(new Date()), dob: null });
    }

  }, [id]);

  // Save data on every change
  useEffect(() => {

    if (guest && Object.keys(guest).length > 0) {
      localStorage.setItem("guest-form", JSON.stringify(guest));
    }

  }, [guest]);



  const getGuest = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_WEB_SERVICES_URL}/overseer/get-guest/${id}`,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      const g = response.data?.guest;
      setGuest(g); // adjust if data is wrapped

        let months = [];
                  if (g.monthly_rents && g.monthly_rents.length) {
                      months = g.monthly_rents.map(row => ({
                          month: dayjs(row.month).format("MMM YYYY"),
                          discount: parseFloat(row.discount || 0)
                      }));
                  } else {
                      months = Array.from({ length: g.invoice_period || 1 }, (_, i) => ({
                          month: dayjs().add(i, 'month').format("MMM YYYY"),
                          discount: 0
                      }));
                  }
                  setMonthlyRows(months);
      
                  // Load saved additional items if exist
                  if (g.additional_items && g.additional_items.length) {
                      const mappedItems = g.additional_items.map(ai => ({
                          id: ai.id,
                          name: ai.name,
                          description: ai.description,
                          rate: parseFloat(ai.rate),
                          discount: parseFloat(ai.discount || 0),
                      }));
                      setGuestItems(mappedItems);
                  }
                  else{
                      setGuestItems([]);
      
                  }
      


    } catch (error) {
      globalErrorHandler(error, navigate);
    } finally {
      setLoading(false);
    }
  };

  const getStates = async () => {
    //  setIsLoading(true);
    try {
      const response = await axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/get-states", {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      });
      if (response?.data?.status) {
        setStates(response.data.states || []);
      } else {
        Swal.fire({ icon: "error", title: "Error", text: "No States Record Found" });
      }
    } catch (error) {
      globalErrorHandler(error, navigate);
    }

  };

  const formatDate = (date) => {
    if (!date) return "";
    return date.toISOString().split("T")[0];
  };

 


    const getTotalSubtotal = () => {
        const baseRate = parseFloat(guest?.monthly_rate || 0);
        const rentSubtotal = monthlyRows.reduce((total, row) => total + baseRate, 0);
        const itemSubtotal = guestItems.reduce((total, item) => total + parseFloat(item.rate || 0), 0);
        return (rentSubtotal + itemSubtotal).toFixed(2);
    };

    const getTotalDiscount = () => {
        const rentDiscount = monthlyRows.reduce((total, row) => total + parseFloat(row.discount || 0), 0);
        const itemDiscount = guestItems.reduce((total, item) => total + parseFloat(item.discount || 0), 0);
        return (rentDiscount + itemDiscount).toFixed(2);
    };

    const getTotalAmountPaid = () => {
        const subtotal = parseFloat(getTotalSubtotal());
        const discount = parseFloat(getTotalDiscount());
        return (subtotal - discount).toFixed(2);
    };


  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid px-4 mt-4 mb-5  " id="guest-main">

      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">Viewing Guest Intake Form: {id}</h3>
      </div>

    
      <div className="card shadow">
        <div className="card-header"><h5 className="mb-0">Basic Information</h5></div>
        <div className="card-body p-4">

          <div className="row g-4">
            {/* Full Name */}
            <div className="col-md-6">
              <label className="form-label">Full Name <span className="text-danger">*</span></label>
              <input type="text" disabled className="form-control" placeholder="Enter full name"
                value={guest?.name || ""} onChange={(e) => setGuest({ ...guest, name: e.target.value })} />
            </div>


            {/* Date of Birth */}
            <div className="col-md-6">
              <label className="form-label">Date of Birth <span className="text-danger">*</span></label>

              <Flatpickr  disabled placeholder="Select a date" className="form-control" value={guest?.dob || ""} onChange={(date) => setGuest({ ...guest, dob: formatDate(date[0]) })} options={{ altInput: true, altFormat: "m/d/Y", dateFormat: "Y-m-d", maxDate: "today" }} />


            </div>



            {/* Gender */}
            <div className="col-md-6">
              <label className="form-label">Gender</label>
              <select disabled className="form-select" value={guest?.gender || ""} onChange={(e) => setGuest({ ...guest, gender: e.target.value })}   >
                <option value="">Select gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>
            </div>

            {/* Social Security Number */}
            <div className="col-md-6">
              <label className="form-label">Social Security Number</label>
              <input type="text" disabled className="form-control" placeholder="XXX-XX-XXXX" value={guest?.ssn || ""} onChange={(e) => setGuest({ ...guest, ssn: e.target.value })}
              />
            </div>

            {/* Email ID */}
            <div className="col-md-6">
              <label className="form-label">Email ID<span className="text-danger">*</span></label>
              <input type="email" disabled className="form-control" placeholder="example@email.com" value={guest?.email || ""} onChange={(e) => setGuest({ ...guest, email: e.target.value })} />
            </div>

            {/* Phone Number */}
            <div className="col-md-6">
              <label className="form-label">Phone Number</label>
              <input type="tel" disabled className="form-control" placeholder="(123) 456-7890" value={guest?.phone || ""} onChange={(e) => setGuest({ ...guest, phone: e.target.value })} />
            </div>
          </div>


        </div>
      </div>



      <div className="card shadow mt-4">
        <div className="card-header"><h5 className="mb-0">Probation/Parole Information</h5></div>
        <div className="card-body p-4">
          <div className="row g-4">
            <div className="col-md-6">
              <label className="form-label">Officer Name</label>
              <input type="text" disabled className="form-control" placeholder="Enter officer's full name" value={guest?.officer_name || ''} onChange={(e) => setGuest({ ...guest, officer_name: e.target.value })} />
            </div>
            <div className="col-md-6">
              <label className="form-label">Officer Phone</label>
              <input type="tel" disabled className="form-control" placeholder="(123) 456-7890" value={guest?.officer_phone || ''} onChange={(e) => setGuest({ ...guest, officer_phone: e.target.value })} />
            </div>
          </div>
        </div>
      </div>






      <div className="card shadow mt-4">
        <div className="card-header"><h5 className="mb-0">Demographics</h5></div>
        <div className="card-body p-4">
          <div className="row g-4">
            <div className="col-md-6">
              <label className="form-label">Ethnicity</label>
              <select disabled className="form-select" value={guest?.ethnicity || ''} onChange={(e) => setGuest({ ...guest, ethnicity: e.target.value })}>
                <option value="">Select ethnicity</option>
                <option value="Hispanic or Latino">Hispanic or Latino</option>
                <option value="Not Hispanic or Latino">Not Hispanic or Latino</option>
              </select>
            </div>
            <div className="col-md-6">
              <label className="form-label">Education Level</label>
              <select disabled className="form-select" value={guest?.education_level || ''} onChange={(e) => setGuest({ ...guest, education_level: e.target.value })}>
                <option value="">Select education level</option>
                <option value="Less than high school">Less than high school</option>
                <option value="High school diploma or equivalent (e.g., GED)">High school diploma or equivalent (e.g., GED)</option>
                <option value="Some college, no degree">Some college, no degree</option>
                <option value="Associate's degree">Associate's degree</option>
                <option value="Bachelor's degree">Bachelor's degree</option>
                <option value="Master's degree">Master's degree</option>
                <option value="Doctoral degree or higher">Doctoral degree or higher</option>
              </select>
            </div>
          </div>
        </div>
      </div>



      <div className="card shadow mt-4">
        <div className="card-header"><h5 className="mb-0">Current Address</h5></div>
        <div className="card-body p-4">
          <div className="row g-4">
            {/* Full Address - Full Width */}
            <div className="col-12">
              <label className="form-label">Street Address</label>
              <input type="text" disabled className="form-control" placeholder="Enter full street address" value={guest?.address || ''} onChange={(e) => setGuest({ ...guest, address: e.target.value })} />
            </div>

            {/* City and State */}
            <div className="col-md-6">
              <label className="form-label">City</label>
              <input type="text" disabled className="form-control" placeholder="Enter city" value={guest?.city || ''} onChange={(e) => setGuest({ ...guest, city: e.target.value })} />
            </div>
            <div className="col-md-6">
              <label className="form-label">State</label>
              <select disabled className="form-select" value={guest?.state || ''} onChange={(e) => setGuest({ ...guest, state: e.target.value })} >
                <option value="">Select state</option>
                {states.map((state, index) => (
                  <option key={index} value={state.state_id}>{state.state_name} {state.state_abbreviation}</option>
                ))}
              </select>
            </div>

            {/* ZIP and Phone */}
            <div className="col-md-6">
              <label className="form-label">ZIP Code</label>
              <input type="text" disabled className="form-control" placeholder="Enter ZIP code" value={guest?.zip || ''} onChange={(e) => setGuest({ ...guest, zip: e.target.value })} />
            </div>
            <div className="col-md-6">
              <label className="form-label">Phone</label>
              <input type="tel" disabled className="form-control" placeholder="(123) 456-7890" value={guest?.address_phone || ''} onChange={(e) => setGuest({ ...guest, address_phone: e.target.value })} />
            </div>
          </div>
        </div>
      </div>




      <div className="card shadow mt-4">
        <div className="card-header"><h5 className="mb-0">Emergency Contact</h5></div>
        <div className="card-body p-4">
          <div className="row g-4">
            {/* Contact Name - Full Width */}
            <div className="col-12">
              <label className="form-label">Contact Name</label>
              <input type="text" disabled className="form-control" placeholder="Enter contact's full name" value={guest?.emergency_contact_name || ''} onChange={(e) => setGuest({ ...guest, emergency_contact_name: e.target.value })} />
            </div>

            {/* Phone and Relationship */}
            <div className="col-md-6">
              <label className="form-label">Phone</label>
              <input type="tel" disabled className="form-control" placeholder="(123) 456-7890" value={guest?.emergency_contact_phone || ''} onChange={(e) => setGuest({ ...guest, emergency_contact_phone: e.target.value })} />
            </div>
            <div className="col-md-6">
              <label className="form-label">Relationship</label>
              <input type="text" disabled className="form-control" placeholder="e.g., Mother, Friend" value={guest?.emergency_contact_relationship || ''} onChange={(e) => setGuest({ ...guest, emergency_contact_relationship: e.target.value })} />
            </div>
          </div>
        </div>
      </div>






      <div className="card shadow mt-4">
        <div className="card-header"><h5 className="mb-0">Employment Status</h5></div>
        <div className="card-body p-4">
          <div className="row g-4">
            {/* Employed / Unemployed Radio */}
            <div className="col-12">
              <label className="form-label d-block">Employment Status</label>

              <div className="form-check form-check-inline  mt-3">
                <input className="form-check-input" type="radio" disabled name="employment_status" id="unemployed" value="unemployed" checked={guest?.employment_status === 'unemployed'} onChange={(e) => setGuest({ ...guest, employment_status: e.target.value })} />
                <label className="form-check-label" htmlFor="unemployed">Unemployed</label>
              </div>
              <div className="form-check form-check-inline  mt-3">
                <input className="form-check-input" type="radio" disabled name="employment_status" id="employed" value="employed" checked={guest?.employment_status === 'employed'} onChange={(e) => setGuest({ ...guest, employment_status: e.target.value })} />
                <label className="form-check-label" htmlFor="employed">Employed</label>
              </div>
            </div>

            {/* Employer and Position - Only if employed */}
            {guest?.employment_status === 'employed' && (
              <>
                <div className="col-md-6">
                  <label className="form-label">Employer</label>
                  <input type="text" disabled className="form-control" placeholder="Enter employer name" value={guest?.employer || ''} onChange={(e) => setGuest({ ...guest, employer: e.target.value })} />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Position</label>
                  <input type="text" disabled className="form-control" placeholder="Enter position" value={guest?.position || ''} onChange={(e) => setGuest({ ...guest, position: e.target.value })} />
                </div>
              </>
            )}

            {/* Source of Income */}
            <div className="col-12">
              <label className="form-label">Source of Income</label>
              <input type="text" disabled className="form-control" placeholder="e.g., Employment, SSI, Disability" value={guest?.income_source || ''} onChange={(e) => setGuest({ ...guest, income_source: e.target.value })} />
            </div>
          </div>
        </div>
      </div>




      <div className="card shadow mt-4">
        <div className="card-header"><h5 className="mb-0">Document Checklist</h5></div>
        <div className="card-body p-4">
          {[
            { key: 'ss_card', label: 'Social Security Card' },
            { key: 'birth_cert', label: 'Birth Certificate' },
            { key: 'photo_id', label: 'Valid Photo ID' },
            { key: 'driver_license', label: 'Driver License' },
            { key: 'assistance', label: 'Food Stamps / Assistance' }
          ].map(item => (
            <div className="mb-4" key={item.key}>
              <div className="form-check mb-4">
                <input className="form-check-input" type="checkbox" disabled id={item.key} checked={guest?.documentChecklist?.[item.key]?.checked || false} onChange={(e) => setGuest({
                  ...guest,
                  documentChecklist: {
                    ...guest?.documentChecklist,
                    [item.key]: {
                      ...guest?.documentChecklist?.[item.key],
                      checked: e.target.checked
                    }
                  }
                })} />
                <label className="form-check-label" htmlFor={item.key}>{item.label}</label>
              </div>
              {!guest?.documentChecklist?.[item.key]?.checked && (
                <>
                  <label className="form-label">If no, provide plan;</label>
                  <textarea disabled className="form-control mt-2" placeholder="Provide plan" value={guest?.documentChecklist?.[item.key]?.note || ''} onChange={(e) => setGuest({
                    ...guest,
                    documentChecklist: {
                      ...guest?.documentChecklist,
                      [item.key]: {
                        ...guest?.documentChecklist?.[item.key],
                        note: e.target.value
                      }
                    }
                  })} />
                </>
              )}
            </div>
          ))}
        </div>
      </div>






      <div className="card shadow mt-4">
        <div className="card-header"><h5 className="mb-0">Recovery Information</h5></div>
        <div className="card-body p-4">
          <div className="row g-4">
            <div className="col-md-12">
              <label className="form-label">Amount of Recovery Clean Time</label>
              <input type="text" disabled className="form-control" placeholder="e.g., 6 months" value={guest?.recovery_clean_time || ''} onChange={(e) => setGuest({ ...guest, recovery_clean_time: e.target.value })} />
            </div>
            <div className="col-md-6">
              <label className="form-label">Drug of Choice</label>
              <input type="text" disabled className="form-control" placeholder="e.g., Alcohol, Heroin" value={guest?.recovery_drug_choice || ''} onChange={(e) => setGuest({ ...guest, recovery_drug_choice: e.target.value })} />
            </div>
            <div className="col-md-6">
              <label className="form-label">Date of Last Usage</label>
              <Flatpickr disabled  placeholder="Select a date" className="form-control" value={guest?.recovery_last_use || ''} onChange={(date) => setGuest({ ...guest, recovery_last_use: formatDate(date[0]) })} options={{ altInput: true, altFormat: "m/d/Y", dateFormat: "Y-m-d" }} />
            </div>
          </div>
        </div>
      </div>






      <div className="card shadow mt-4">
        <div className="card-header"><h5 className="mb-0">Medical & Mental Health</h5></div>
        <div className="card-body p-4">
          <div className="row g-4">

            {/* Group 1: Medications */}
            <div className="col-12">
              <label className="form-label d-block">Are you currently taking any medications?</label>
              <div className="form-check form-check-inline  mt-3">
                <input className="form-check-input" type="radio" disabled name="on_medications" id="medYes" value="yes" checked={guest?.on_medications === 'yes'} onChange={(e) => setGuest({ ...guest, on_medications: e.target.value })} />
                <label className="form-check-label" htmlFor="medYes">Yes</label>
              </div>
              <div className="form-check form-check-inline  mt-3">
                <input className="form-check-input" type="radio" disabled name="on_medications" id="medNo" value="no" checked={guest?.on_medications === 'no'} onChange={(e) => setGuest({ ...guest, on_medications: e.target.value })} />
                <label className="form-check-label" htmlFor="medNo">No</label>
              </div>
              {guest?.on_medications === 'yes' && (
                <textarea disabled className="form-control mt-3" placeholder="If yes, list all medications here" value={guest?.medications || ''} onChange={(e) => setGuest({ ...guest, medications: e.target.value })} />
              )}
            </div>

            {/* Group 2: suicide_history Thoughts */}
            <div className="col-12">
              <label className="form-label d-block">Have you ever thought about, or attempted suicide?</label>
              <div className="form-check form-check-inline  mt-3">
                <input className="form-check-input" type="radio" disabled name="suicide_history" id="suicideYes" value="yes" checked={guest?.suicide_history === 'yes'} onChange={(e) => setGuest({ ...guest, suicide_history: e.target.value })} />
                <label className="form-check-label" htmlFor="suicideYes">Yes</label>
              </div>
              <div className="form-check form-check-inline  mt-3">
                <input className="form-check-input" type="radio" disabled name="suicide_history" id="suicideNo" value="no" checked={guest?.suicide_history === 'no'} onChange={(e) => setGuest({ ...guest, suicide_history: e.target.value })} />
                <label className="form-check-label" htmlFor="suicideNo">No</label>
              </div>
            </div>

            {/* Group 3: Currently in Treatment */}
            <div className="col-12">
              <label className="form-label d-block">Are you currently attending treatment?</label>
              <div className="form-check form-check-inline  mt-3">
                <input className="form-check-input" type="radio" disabled name="attending_treatment" id="treatmentYes" value="yes" checked={guest?.attending_treatment === 'yes'} onChange={(e) => setGuest({ ...guest, attending_treatment: e.target.value })} />
                <label className="form-check-label" htmlFor="treatmentYes">Yes</label>
              </div>
              <div className="form-check form-check-inline  mt-3">
                <input className="form-check-input" type="radio" disabled name="attending_treatment" id="treatmentNo" value="no" checked={guest?.attending_treatment === 'no'} onChange={(e) => setGuest({ ...guest, attending_treatment: e.target.value, treatment_where: '', counselor_name: '' })} />
                <label className="form-check-label" htmlFor="treatmentNo">No</label>
              </div>
            </div>

            {guest?.attending_treatment === 'yes' && (
              <>
                <div className="col-md-6">
                  <label className="form-label">Where</label>
                  <input type="text" disabled className="form-control" placeholder="Enter treatment location" value={guest?.treatment_where || ''} onChange={(e) => setGuest({ ...guest, treatment_where: e.target.value })} />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Counselor Name</label>
                  <input type="text" disabled className="form-control" placeholder="Enter counselor name" value={guest?.counselor_name || ''} onChange={(e) => setGuest({ ...guest, counselor_name: e.target.value })} />
                </div>
              </>
            )}



            {/* Group 4: Currently Attending Therapy */}
            <div className="col-12">
              <label className="form-label d-block">Are you currently attending therapy?</label>
              <div className="form-check form-check-inline  mt-3">
                <input className="form-check-input" type="radio" disabled name="attending_therapy" id="therapyYes" value="yes" checked={guest?.attending_therapy === 'yes'} onChange={(e) => setGuest({ ...guest, attending_therapy: e.target.value })} />
                <label className="form-check-label" htmlFor="therapyYes">Yes</label>
              </div>
              <div className="form-check form-check-inline  mt-3">
                <input className="form-check-input" type="radio" disabled name="attending_therapy" id="therapyNo" value="no" checked={guest?.attending_therapy === 'no'} onChange={(e) => setGuest({ ...guest, attending_therapy: e.target.value, therapy_where: '', therapist_name: '' })} />
                <label className="form-check-label" htmlFor="therapyNo">No</label>
              </div>
            </div>

            {guest?.attending_therapy === 'yes' && (
              <>
                <div className="col-md-6">
                  <label className="form-label">Where</label>
                  <input type="text" disabled className="form-control" placeholder="Enter therapy location" value={guest?.therapy_where || ''} onChange={(e) => setGuest({ ...guest, therapy_where: e.target.value })} />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Therapist's Name</label>
                  <input type="text" disabled className="form-control" placeholder="Enter therapist's name" value={guest?.therapist_name || ''} onChange={(e) => setGuest({ ...guest, therapist_name: e.target.value })} />
                </div>
              </>
            )}



          </div>
        </div>
      </div>






      <div className="card shadow mt-4">
        <div className="card-header"><h5 className="mb-0">Religious Affiliation</h5></div>
        <div className="card-body p-4">
          <div className="row g-4">
            <div className="col-12">
              <label className="form-label">Do you have any church in your background:</label>
              <textarea disabled rows="5" className="form-control" placeholder="Write your response here" value={guest?.religious_background || ''} onChange={(e) => setGuest({ ...guest, religious_background: e.target.value })} />
            </div>
          </div>
        </div>
      </div>




      <div className="card shadow mt-4">
        <div className="card-header"><h5 className="mb-0">Image Release</h5></div>
        <div className="card-body p-4">
          <div className="row g-4">
            <div className="col-12">
              <label className="form-label d-block">Do you give BBM consent to post pictures or videos on social media or other advertising platforms?</label>
              <div className="form-check form-check-inline mt-3">
                <input className="form-check-input" type="radio" disabled name="image_release" id="imageYes" value="yes" checked={guest?.image_release === 'yes'} onChange={(e) => setGuest({ ...guest, image_release: e.target.value })} />
                <label className="form-check-label" htmlFor="imageYes">Yes</label>
              </div>
              <div className="form-check form-check-inline mt-3">
                <input className="form-check-input" type="radio" disabled name="image_release" id="imageNo" value="no" checked={guest?.image_release === 'no'} onChange={(e) => setGuest({ ...guest, image_release: e.target.value })} />
                <label className="form-check-label" htmlFor="imageNo">No</label>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div className="card shadow mt-4">
        <div className="card-header"><h5 className="mb-0">Free Through Recovery Program or Community Connect</h5></div>
        <div className="card-body p-4">
          <div className="row g-4">

            {/* Enrolled? */}
            <div className="col-12">
              <label className="form-label d-block">Are you enrolled in FTR or CC programming?</label>
              <div className="form-check form-check-inline">
                <input className="form-check-input" type="radio" disabled name="ftr_enrolled" id="ftrYes" value="yes" checked={guest?.ftr_enrolled === 'yes'} onChange={(e) => setGuest({ ...guest, ftr_enrolled: e.target.value, ftr_interest: '' })} />
                <label className="form-check-label" htmlFor="ftrYes">Yes</label>
              </div>
              <div className="form-check form-check-inline">
                <input className="form-check-input" type="radio" disabled name="ftr_enrolled" id="ftrNo" value="no" checked={guest?.ftr_enrolled === 'no'} onChange={(e) => setGuest({ ...guest, ftr_enrolled: e.target.value, ftr_provider: '' })} />
                <label className="form-check-label" htmlFor="ftrNo">No</label>
              </div>
            </div>

            {/* If Yes - Show Name & Agency */}
            {guest?.ftr_enrolled === 'yes' && (
              <div className="col-12">
                <textarea disabled className="form-control" placeholder="If yes, Name and Agency of FTR or CC provider" value={guest?.ftr_provider || ''} onChange={(e) => setGuest({ ...guest, ftr_provider: e.target.value })} />
              </div>
            )}

            {/* If No - Ask interest */}
            {guest?.ftr_enrolled === 'no' && (
              <div className="col-12">
                <label className="form-label d-block">If not, are you interested in FTR or CC programming if qualified?</label>
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="radio" disabled name="ftr_interest" id="ftrInterestYes" value="yes" checked={guest?.ftr_interest === 'yes'} onChange={(e) => setGuest({ ...guest, ftr_interest: e.target.value })} />
                  <label className="form-check-label" htmlFor="ftrInterestYes">Yes</label>
                </div>
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="radio" disabled name="ftr_interest" id="ftrInterestNo" value="no" checked={guest?.ftr_interest === 'no'} onChange={(e) => setGuest({ ...guest, ftr_interest: e.target.value })} />
                  <label className="form-check-label" htmlFor="ftrInterestNo">No</label>
                </div>
              </div>
            )}

          </div>
        </div>
      </div>



     

    <div className="card shadow mt-4">
        <div className="card-header"><h5 className="mb-0">Move In </h5></div>
        <div className="card-body p-4">
  
      <div className="row g-4">
                     <div className="col-lg-12">
                       <table className="table table-responsive table-bordered text-nowrap">
                         <thead className="table-success">
                           <tr>
                             <th>Property</th>
                             <th>Floor</th>
                             <th>Room</th>
                             <th>Bed Type</th>
                             <th>Rate</th>
                           </tr>
                         </thead>
                         <tbody>
                           <tr>
                             <td>{guest?.property_name || "-"}</td>
                             <td>{guest?.floor_name || "-"}</td>
                             <td>{guest?.room_no || "-"}</td>
                             <td>{guest?.bedtype || "-"}</td>
                             <td>${guest?.monthly_rate || "0.00"}</td>
                           </tr>
                         </tbody>
                       </table>
     
                       {/* Move-In Details Row */}
                       <div className="row g-3 border-top border-bottom my-5">
                         <div className="col-md-6 border-end border-dark-subtle mt-0 py-4">
                           <label className="form-label text-danger">Desired Move-In Date</label>
                           <Flatpickr disabled placeholder="Select a date" style={{ maxWidth: "250px" }} className="form-control bg-transparent" name="desired_move_in_date" options={{ dateFormat: 'Y-m-d' }} value={guest?.desired_move_in_date}  />
                         </div>
                         <div className="col-md-6">
                           <div className="px-2">
                             <div className="d-flex justify-content-between my-2">Rent Rate<span>${guest?.monthly_rate || "0.00"}</span></div>
                           </div>
                         </div>
                       </div>
     
                     </div>
                   </div>
 </div>
  </div>







  <div className="card shadow mt-4">
        <div className="card-header"><h5 className="mb-0">Door Code  </h5></div>
        <div className="card-body p-4">


 <div className="row g-5 mb-3">
              <div className="col-md-6">
                <h5>Billing</h5>

                <div className="row g-2 mt-4">
                  <div className="col-md-6">

                    <label className="form-label fw-bold">Move-In Date</label>
                    <Flatpickr disabled placeholder="Select a date" className="form-control" name="move_in_date" options={{ dateFormat: 'Y-m-d' }} value={guest?.move_in_date} />

                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Invoice Period (Months)</label>
                    <select disabled
                      className="form-select"
                      name="invoice_period"
                      value={guest?.invoice_period}
                   
                    >
                      <option value="">Select</option>
                      {[...Array(36)].map((_, i) => (
                        <option key={i + 1} value={i + 1}>
                          {i + 1} month{i > 0 ? "s" : ""}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Row 2: Invoice Method */}
                <div className="row mt-4">
                  <div className="col-12 ">

                    <div className="form-check mb-3 fw-bold">
                      <input className="form-check-input" type="radio" disabled name="invoice_method" id="invoiceEmail" value="email" checked={guest?.invoice_method === "email"}
                        
                      />
                      <label className="form-check-label" htmlFor="invoiceEmail">Receive invoices via email</label>
                    </div>

                    <div className="form-check fw-bold">
                      <input className="form-check-input" type="radio" disabled name="invoice_method" id="invoicePrinted" value="printed" checked={guest?.invoice_method === "printed"}
                      
                      />
                      <label className="form-check-label" htmlFor="invoicePrinted">Receive printed invoices</label>

                    </div>
                  </div>
                </div>
              </div>
              {/* Row 3: Door Code */}

              <div className="col-md-6">
                <h5>Door Code</h5>
                <div className="row mt-4">
                  <div className="col-md-12 mt-2">
                    <label className="form-label">Door Code</label>
                    <input           type="text" disabled
                      className="form-control"
                      name="door_code"
                      value={guest?.door_code}
                    />
                  </div>
                </div>
              </div>
            </div>


              </div>
  </div>

  






  <div className="card shadow mt-4">
        <div className="card-header"><h5 className="mb-0">Billing & Additional Items</h5></div>
        <div className="card-body p-4">





                            <table className="table table-bordered">
                                <tbody>
                                    <tr>
                                        <th>Bed</th>
                                        <th>Bed Type</th>
                                        <th>Month</th>
                                        <th>Rate</th>
                                        <th>Discount</th>
                                        <th>Subtotal</th>
                                    </tr>
                                    {monthlyRows.map((row, index) => (
                                        <tr key={index}>
                                            <td>{guest?.bed_id}</td>
                                            <td>{guest?.bedtypename}</td>
                                            <td>{row.month}</td>
                                            <td>${parseFloat(guest?.monthly_rate).toFixed(2)}</td>
                                            <td>
                                              
                                                    <div className="d-flex align-items-center gap-2">
                                                        <span className="text-success fw-bold mb-0">${row.discount}</span>
                                                        
                                                    </div>
                                            </td>
                                            <td>${(parseFloat(guest?.monthly_rate) - (row.discount || 0)).toFixed(2)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

<div className="row">
 <div className="col-md-12 my-3">
                <h5>Additional Items</h5>
                </div>
</div>
                            <table className="table table-bordered">
                                <tbody>
                                    <tr>
                                        <th>Item</th>
                                        <th>Description</th>
                                        <th>Rate</th>
                                        <th>Discount</th>
                                        <th>Subtotal</th>
                                    </tr>
                                    {guestItems.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.name}</td>
                                            <td>{item.description}</td>
                                            <td>${parseFloat(item.rate).toFixed(2)}</td>
                                            <td>
                                               
                                                    <div className="d-flex align-items-center gap-2">
                                                        <span className="text-success fw-bold mb-0">${parseFloat(item.discount).toFixed(2)}</span>
                                                      
                                                    </div>
                                            
                                            </td>
                                            <td>${(item.rate - (item.discount || 0)).toFixed(2)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>


                                   <div className="row g-3 border-top border-bottom my-5">
                        <div className="col-md-6 border-end border-dark-subtle mt-0 py-4">

                            <h5 className="mb-3">Mode of Payment</h5>
                                                        <div className="d-flex flex-direction-row" >

                            <div className="form-check mb-3" >
                                <input className="form-check-input" type="radio" disabled name="mode_of_payment" id="modeOfPaymentOnline" value="online" checked={guest?.mode_of_payment === "online"} />
                                <label className=" form-check-label" htmlFor="invoiceEmail">Online payment with credit card</label>
                            </div>
                            <div className="form-check"  >
                                <input className="form-check-input" type="radio" disabled name="mode_of_payment" id="modeOfPaymentOffline" value="offline" checked={guest?.mode_of_payment === "offline"}  />
                                <label className=" form-check-label" htmlFor="invoicePrinted">Pay at office with Cash or Check</label>

                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                            <div className="px-2">
                              

                                <div className="row mb-3">
                                    <div className="col">Subtotal:</div>
                                    <div className="col text-end">${getTotalSubtotal()}</div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col">Discount:</div>
                                    <div className="col text-end">${getTotalDiscount()}</div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col fw-bold">Total Amount Due:</div>
                                    <div className="col text-end">
                                        ${(getTotalSubtotal() - getTotalDiscount()).toFixed(2)}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>



  </div>
  </div>
  







    </div>




  );
};

export default GuestIntakeFormView;
